import { createTheme } from "@mui/material";

const theme = createTheme({
  palette: {
    primary: {
      main: "#158cde",
      dark: "#222",
    },
    secondary: {
      main: "#f0eeee",
      dark: "#158cde",
    },
  },
});

export default theme;
